export default __webpack_public_path__ + "static/media/OSMOS_TORTORA_C2_GRIP_120X120_03.e1771cbf.jpg";